// El editor solo admite markdown como valor inicial
// Este paquete transforma HTML a markdown
// import TurndownService from 'turndown'
import Vue from 'vue'

import {Viewer} from '@toast-ui/vue-editor'

import ProductDataMixin from '../../../_product-data.js'

import template from './index.pug'

// @vue/component
export default {
  template: template(),

  components: {Viewer},

  mixins: [ProductDataMixin],

  props: {
    product: {
      type: Object,
      required: true
    },
    currentTab: {
      type: String
    }
  },

  data() {
    return {
      seeConditions: false,
      viewerInitialContent: ''
    }
  },

  computed: {
    stopFromLabel() {
      const {stop_from_display_code: stopDisplayCode, stop_from_name: stopName} = this.product

      return this.formatLabel([stopDisplayCode, stopName])
    },
    stopToLabel() {
      const {stop_to_display_code: stopDisplayCode, stop_to_name: stopName} = this.product

      return this.formatLabel([stopDisplayCode, stopName])
    },
    variantLabel() {
      const {variant_mask: variantMask, variant_name: variantName} = this.product

      return this.formatLabel([variantMask, variantName])
    },
    // eslint-disable-next-line consistent-return, vue/return-in-computed-property
    showOriginDestination() {
      if (this.product.origin_destination_type === 'origin_destination_price') {
        return true
      }
    }
  },

  created() {
    if (this.product.conditions) {
      this.viewerInitialContent = this.product.conditions[this.$i18n.locale]
    }
  },

  methods: {
    toggleConditions() {
      this.seeConditions = !this.seeConditions
    },
    formatLabel(values) {
      return values.join(' | ')
    },
    supportTypeText(support_entity_type) {
      return Vue.i18n.t(
        `balance.products.productsData.supportEntityTypes.${support_entity_type}`
      )
    }

  }
}
